
import Vue from "vue";
import { mask } from "vue-the-mask";
import { mapMutations, mapState } from 'vuex';
import { FilterIcon, PlusIcon, SaveIcon } from 'vue-feather-icons'
import { flattenDeep } from "lodash";
import UnitPlan from "@/store/units/UnitPlan";
import { Ripple } from "vuetify/lib/directives";
import RomaOaModalForm from "../objetive/RomaOaModalForm.vue";
import UnitPlanOa from "../../../store/planner/objetive/UnitPlanOa";
import UnitPlanActivity from "../../../store/planner/activity/UnitPlanActivity";
import RomaMessageModal from "../../commons/RomaMessageModal.vue";
import UnitPlanComments from "../../../store/units/UnitPlanComments";
import RomaActivityModalForm from "../activity/RomaActivityModalForm.vue";
import { filter } from "vue/types/umd";
import { ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon, EyeIcon, EyeOffIcon, CheckIcon, CheckSquareIcon, EditIcon } from 'vue-feather-icons';
import _ from 'lodash';
import { nonWorkingDates } from '../../../data/nonWorkingDates'

//interfaces
import { IUnitPlan } from "@/interfaces/units/IUnitPlan";

// @ts-ignore
export default Vue.extend({
  name: "RomaCoverage",
  beforeDestroy() {
    window.onbeforeunload = () => undefined;
    window.removeEventListener('resize', this.getWidth);
  },
  created() {
    window.onbeforeunload = (event: any) => {
      if (!this.savedCoverage) {
        // Cancel the event as stated by the standard.
        event.preventDefault();
        // Chrome requires returnValue to be set.
        return "Hay cambios sin guardar en organización, desea continuar?";
      }
    };
    this.loading = true;
    this.getWeeks();
    this.getOAsByUnitPlanId();
    // TODO: Cargar cobertura previa
    this.selectedMenu = this.menuIE;
    this.$emit("refresh-activities", true);
  },
  mounted() {

  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    executeSaveCoverage: {
      type: Boolean,
      default: false,
    },
    titleWidth: {
      type: String,
      default: "480",
    },
    height: {
      type: String,
      default: window.innerHeight > 600 ? `${window.innerHeight * 0.50}` : '400',
    },
    applyRowColor: {
      type: Boolean,
      default: true,
    },
    hideFilters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      firstExpanded: false,
      oasHeaderTableWidth: 270,
      haveItemsSelected: false,
      originalItemsCount: [],
      selectedRows: [],
      pageCount: 0,
      selectedActivity: null,
      filterBy: {
        field: "",
        value: 0,
      },
      filterSection: false,
      itemSelected: null,
      parcialRequest: {
        idPlanUnidadOA: 0,
        idPlanUnidad: 0,
      },
      filter: {
        crit: null,
        disabled: true,
      },
      selectedAll: false,
      buttons: [
        {
          disabled: false,
          label: "activitiesButtonLabel",
          icon: "fas fa-user-check",
          onClick: () => {
            this.selectedIEsForActivities = this.selectedRows.slice();
            this.dialogActivity = true;
          },
          enable:
            this.$store.state.user.privileges.canSeeUnitCoverageAndActivities,
        },
        {
          disabled: false,
          label: "reprogramButtonLabel",
          icon: "fas fa-times-circle",
          onClick: () => {
            this.toggleOa(this.selectedRows, true);
          },
          enable:
            this.$store.state.user.privileges
              .canEditCoverageAndActivitiesAndReprogramOAAndAdvanceAndComment &&
            (this.unit.plan_status_id === 1 || this.unit.plan_status_id === 2),
        },
      ],
      loading: false,
      firstLoadToSave: true,
      expandIndicatorsDetails: false,
      semanas: [],
      selectedIEsForActivities: [],
      weekItemSelected: {},
      monthSelected: {},
      dialogActivity: false,
      userId: this.$store.state.user.userId,
      userPrivileges: this.$store.state.user.privileges,
      isUTP: this.$store.state.user.isUTP,
      unitplan_weeks: [],
      // Navegación


      selectedMonthIndex: 0,
      selectedMonths: null,
      showingMenu: false,
      selectedMenu: null,
      // Menu
      menuX: 0,
      menuY: 0,
      expanded: [],
      dialog: false,
      messageDialog: false,
      // Peticion
      request: null,
      selectedWeek: null,
      selectedMark: null,
      headers: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
      ],
      unitPlanIEs: [],
    };
  },
  computed: {
    menuOA() {
      return [
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.assignOA"
          ),
          color: "blue",
          icon: "circle",
          type: 0,
        },
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.assignAssessment"
          ),
          color: "green",
          icon: "circle-green",
          type: 2,
        },
      ];
    },
    menuIE() {
      return [
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.assignIE"
          ),
          color: "blue",
          type: 1,
        },
      ];
    },
    altMenuOA() {
      return [
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.deletePlanification"
          ),
          icon: "circle-gray",
          color: "",
          onClick: () => {
            let index = this.selectedWeek.planUnidadSemanaItemToList.findIndex(
              (r) =>
                (!!this.selectedMark.id &&
                  this.selectedMark.id > 0 &&
                  this.selectedMark.id === r.id) ||
                (r.idPlanUnidadSemana ===
                  this.selectedMark.idPlanUnidadSemana &&
                  this.selectedMark.tipo === r.tipo &&
                  this.selectedMark.ie_id === r.ie_id &&
                  this.selectedMark.idPlanUnidadOA === r.idPlanUnidadOA)
            );
            if (index >= 0) {
              this.$delete(this.selectedWeek.planUnidadSemanaItemToList, index);
              this.selectedMark.tipo = null;
              this.showingMenu = false;
            }
            this.verifyItemsSelected();
          },
        },
      ];
    },
    altMenuIE() {
      let menuIE = [
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.registerAdvance"
          ),
          icon: "check",
          color: "blue",
          onClick: () => {
            this.oasAdded.forEach((oaAdded: any) => {
              oaAdded.test = true;
            });
            let item = this.selectedWeek.planUnidadSemanaItemToList.find((item: any) => item.ie_id === this.itemSelected.id);

            if (item.estadoRealizado === 3) {
              item.estadoRealizado = 0;
            } else {
              this.selectedWeek.planUnidadSemanaItemToList.find(
                (item: any) => item.ie_id === this.itemSelected.id
              ).estadoRealizado = 3;
            }
            this.showingMenu = false;
          },
        },
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.deletePlanification"
          ),
          icon: "circle-gray",
          color: "",
          onClick: () => {
            let index = this.selectedWeek.planUnidadSemanaItemToList.findIndex(
              (r) =>
                (!!this.selectedMark.id &&
                  this.selectedMark.id > 0 &&
                  this.selectedMark.id === r.id) ||
                (r.idPlanUnidadSemana ===
                  this.selectedMark.idPlanUnidadSemana &&
                  this.selectedMark.tipo === r.tipo &&
                  this.selectedMark.ie_id === r.ie_id &&
                  this.selectedMark.idPlanUnidadOA === r.idPlanUnidadOA)
            );
            if (index >= 0) {
              this.$delete(this.selectedWeek.planUnidadSemanaItemToList, index);
              this.selectedMark.tipo = null;
              this.showingMenu = false;
            }
            this.verifyItemsSelected();
          },
        },
      ];

      if (this.unit && this.unit.totalIesPlanned != this.unit.totalIesDefined) {
        menuIE.shift();
      }

      return menuIE;
    },
    altMenuIE2() {
      return [
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.deleteAdvance"
          ),
          icon: "check",
          color: "blue",
          onClick: () => {
            let item = this.selectedWeek.planUnidadSemanaItemToList.find((item: any) => item.ie_id === this.itemSelected.id);
            if (item.estadoRealizado === 3) {
              item.estadoRealizado = 0;
            } else {
              this.selectedWeek.planUnidadSemanaItemToList.find(
                (item: any) => item.ie_id === this.itemSelected.id
              ).estadoRealizado = 3;
            }
            this.showingMenu = false;

            this.verifyItemsSelected();
          },
        },
        {
          label: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.deletePlanification"
          ),
          icon: "circle-gray",
          color: "",
          onClick: () => {
            let index = this.selectedWeek.planUnidadSemanaItemToList.findIndex(
              (r) =>
                (!!this.selectedMark.id &&
                  this.selectedMark.id > 0 &&
                  this.selectedMark.id === r.id) ||
                (r.idPlanUnidadSemana ===
                  this.selectedMark.idPlanUnidadSemana &&
                  this.selectedMark.tipo === r.tipo &&
                  this.selectedMark.ie_id === r.ie_id &&
                  this.selectedMark.idPlanUnidadOA === r.idPlanUnidadOA)
            );
            if (index >= 0) {
              this.$delete(this.selectedWeek.planUnidadSemanaItemToList, index);
              this.selectedMark.tipo = null;
              this.showingMenu = false;
            }
            this.verifyItemsSelected();
          },
        },
      ];
    }
    , getUnitPlan(): IUnitPlan {
      if (this.unit === null || this.unit === undefined) {
        return {
          itemsPlannedPercentage: 0,
          itemsDonePercentage: 0,
          status_plan: '',
          hours: 0,
          oa_count: 0,
          activity_count: 0
        }
      }

      const unitPlan = UnitPlan.query()
        .where('id', this.unit.id)
        .withAll()
        .first();
      return unitPlan;
    },
    oasActiveLength() {
      let unitPlanOA = UnitPlanOa.getAllByPlanUnidad(this.unit.id).filter((item: any) => {
        let returnValue: boolean;
        if (item.oa && item.oa.ies) {
          let find = item.oa.ies.find(ie => !ie.disabled)
          returnValue = find != undefined;

          if (find == null) {
            returnValue = !item.disabled;
          }
        } else {
          returnValue = !item.disabled;
        }
        return returnValue;
      });
      return unitPlanOA.length;
    },
    oasAdded() {
      let unitPlanOA = UnitPlanOa.getAllByPlanUnidad(this.unit.id).filter(
        (item) => {
          let returnValue;

          if (item.oa && item.oa.ies) {
            if (item.disabled != !this.filter.disabled) {
              returnValue = false;
            } else {
              let find = item.oa.ies.find(ie => ie.disabled == !this.filter.disabled)
              returnValue = find != undefined;

              if (find == null) {
                returnValue = item.disabled == !this.filter.disabled;
              }
            }
          } else {
            returnValue = item.disabled == !this.filter.disabled;
          }
          return returnValue;
        }
      ).sort(
        function (a: any, b: any) {
          if (a.oa && b.oa && a.oa.cod_eje > b.oa.cod_eje) { return 1; }
          if (a.oa && b.oa && a.oa.cod_eje < b.oa.cod_eje) { return -1; }
          return 0;
        }
      ).map((item: any) => {
        if (item.oa && item.oa.ies) {
          item.oa.ies = item.oa.ies.filter((item: any) => item.name != '-' && this.unitPlanIEs.some((ie: any) => ie.id == item.id));
        }

        return item;
      });
      if (!this.firstExpanded && unitPlanOA.length > 0) {
        this.firstExpanded = true;
        this.expanded = [unitPlanOA[0]];
      }

      return unitPlanOA;
    },
    savedCoverage() {
      const items: any[] = this.unitplan_weeks
        .flatMap((month: any) => month.semanas)
        .flatMap((week: any) => week.planUnidadSemanaItemToList);

      if (items.length >= this.originalItemsCount.length) {
        return items.every(
          (item: any) =>
            item.id &&
            this.originalItemsCount.some(
              (originalItem: any) =>
                originalItem.id && originalItem.id === item.id
            )
        );
      } else {
        return this.originalItemsCount.every(
          (item: any) =>
            item.id &&
            items.some(
              (originalItem: any) =>
                originalItem.id && originalItem.id === item.id
            )
        );
      }
    },
    isIndeterminate() {
      let opt = false;
      if (
        this.selectedRows.length !== this.unit.oas.length &&
        this.selectedRows.length !== 0
      )
        opt = true;
      return opt;
    },
    boxSize() {
      let itemsQty = 0;
      let max = 0;
      this.unitplan_weeks.forEach(
        (month: any) => {
          if (month.semanas.length > max) {
            max = month.semanas.length;
          }
        }
      );
      itemsQty = this.unitplan_weeks.length * max;

      if (itemsQty < 8) {
        return '100%';
      }
      return '150px';
    }
  },
  watch: {
    executeSaveCoverage(newValue) {
      if (newValue) {
        this.saveCoverage();
      }
    },
    dialog(newValue) {
      if (!newValue) {
        this.getOAsByUnitPlanId();
        this.$emit('refresh-activities');
      }
    },
    oasAdded(newValue) {
      this.verifyItemsSelected();
    },
    savedCoverage(newValue) {
      this.$emit("saved-coverage", newValue);
    },
    request(newValue) {
      this.verifyItemsSelected();
    },
    filter: {
      deep: true,
      handler(value) {
        if (value.disabled === undefined) value.disabled = null;
        if (!value.crit) value.crit = "";
        this.$set(this.filter, "crit", value.crit);
      },
    },
    expandIndicatorsDetails: {
      deep: true,
      handler(value) {
        if (value) {
          this.oasHeaderTableWidth = 550;
        } else {
          this.oasHeaderTableWidth = 270;
        }
      },
    },
  },
  methods: {
    goToActivity(week: any) {
      this.$emit('go-to-activity', week);
    },
    ...mapMutations(['appLoading', 'planAnualList']),
    validateIfAtLeastPlanned() {
      return this.getUnitPlan.totalIesPlanned > 0 && this.getUnitPlan.totalIesPlanned == this.getUnitPlan.totalIesDefined;
    },
    getIEList(oa: any, filterValue) {
      return oa.ies.filter((ie) => ie.disabled == !filterValue);
    },
    async toggleOa(unitPlanOAs, reprogram: boolean = false) {
      this.loading = true;
      this.appLoading();
      // this.buttons[1].disabled = true;
      // this.buttons[2].disabled = true;
      if (Array.isArray(unitPlanOAs)) {
        let toggleOATOList: any[] = [];
        let IEIds: number[] = [];

        unitPlanOAs.forEach((upOA) => {
          toggleOATOList.push({
            idPlanUnidadOA: upOA.id,
            changeStatus: upOA.changeStatus,
          });
          IEIds = IEIds.concat(upOA.selectedRows.map((ie) => ie.id));
        });

        const toggle: any = {
          toggleOATOList: toggleOATOList,
          ieids: IEIds,
          reprogram,
          dontChangeStatus: false,
        };

        const response = await this.$store.dispatch("toggleUnitPlanOA", toggle);
        let msj = {
          show: true,
          text: "",
          color: "success",
        };
        if (response.data && response.data.status && response.data.status.code === 1) {
          const propertyToToggle: string = toggle.reprogram
            ? "rescheduled"
            : "disabled";
          msj.text = reprogram
            ? this.$vuetify.lang.t(
              "$vuetify.component.romaOA.endpointMessages.reprogramSuccess"
            )
            : this.$vuetify.lang.t(
              "$vuetify.component.romaOA.endpointMessages.changeStatusSuccess"
            );
          unitPlanOAs.forEach((upOA) => {
            if (upOA.changeStatus)
              upOA[propertyToToggle] = !upOA[propertyToToggle];
            upOA.selectedRows.forEach((ie) => {
              if (upOA.changeStatus) {
                ie[propertyToToggle] = upOA[propertyToToggle];
              } else {
                ie[propertyToToggle] = !ie[propertyToToggle];
              }
              if (!!ie.rescheduled) ie.disabled = true;
            });
            if (!upOA.changeStatus)
              upOA[propertyToToggle] = upOA.oa.ies.every(
                (ie) => ie[propertyToToggle]
              );
            delete upOA.changeStatus;
            upOA.selectedRows = [];
            if (!!upOA.rescheduled) upOA.disabled = true;
          });
          this.selectedRows = [];
          UnitPlanOa.update({ data: unitPlanOAs });
          this.unit.updateStatus(response.data.content.status);
          this.unit.updatePercentages(response.data.content.percentages);
          this.unit.updateOaCount(this.oasActiveLength);
          const commentsToInsert = response.data.content.comments.filter(
            (comment: any) => !!comment
          );
          if (commentsToInsert.length > 0)
            UnitPlanComments.insert({ data: commentsToInsert });
        } else if (
          response.data &&
          response.data.status &&
          response.data.status.code === 3
        ) {
          msj.text = response.data.content.message;
          msj.color = "red";
        } else {
          msj.text = this.$vuetify.lang.t(
            "$vuetify.generals.endpointMessages.notProcessed"
          );
          msj.color = "red";
        }

        this.$store.state.snackbar = msj;
        //this.getWeeks();
        this.oasAdded;
        this.appLoading(false);
      }
      this.loading = false;
      // this.buttons[1].disabled = false;
      // this.buttons[2].disabled = false;
    },
    markVacationsWeek(nonWorkingDates: any[]) {
      nonWorkingDates = nonWorkingDates.map((dates: any) => {
        return {
          init: new Date(dates.initialDate),
          end: new Date(dates.finalDate)
        };
      });
      this.semanas = this.semanas.map((week: any) => {
        let initWeekDate = new Date(week.fechaInicio.slice(0, 10));
        let endWeekDate = new Date(week.fechafin.slice(0, 10));
        week.initWeekDate = initWeekDate;
        week.endWeekDate = endWeekDate;

        let isNonWorking = nonWorkingDates.some((dates: any) => {
          return initWeekDate >= dates.init && endWeekDate <= dates.end;
        });

        week.vacation = isNonWorking;

        return week;
      });
    },
    async getWeeks() {
      this.$store.dispatch("getUnitPlanWeeks", this.unit.id).then((response) => {
        this.unitplan_weeks = response.data.content;
        if (this.unitplan_weeks.length > 1) {
          this.selectedMonths = this.unitplan_weeks.slice(
            this.selectedMonthIndex,
            this.selectedMonthIndex + 2
          );
        } else {
          this.selectedMonths = this.unitplan_weeks;
        }
        this.semanas = this.unitplan_weeks.flatMap((month: any) => month.semanas);
        this.markVacationsWeek(nonWorkingDates);
        this.updateOriginalItemsCount();
        this.firstLoadToSave = false;
        this.loading = false;
      });
    },
    registerColumnAdvance(mindex, windex, toggle) {
      this.unitplan_weeks[mindex].semanas[windex].planUnidadSemanaItemToList = this.unitplan_weeks[mindex].semanas[windex].planUnidadSemanaItemToList.map((ie: any) => {
        if (toggle) {
          ie.estadoRealizado = 3;
        } else {
          ie.estadoRealizado = 0;
        }
        return ie;
      });
    },
    advanceOa(week: any) {
      let ies = week.planUnidadSemanaItemToList.filter((item: any) => item.ie_id);
      let dones = ies.filter((item: any) => item.estadoRealizado === 3);
      return ies.length > 0 ? ((100 * dones.length) / ies.length).toFixed(0) : 0;
    },
    setPageCount(count) {
      this.pageCount = count;
    },
    commentsCount(item: any) {
      return UnitPlanComments.query().where("idPlanUnidadOA", item.id).count();
    },
    addComment(item: any, event: any) {
      event.stopPropagation();
      this.messageDialog = true;
      this.parcialRequest = {
        idPlanUnidadOA: item.id,
        idPlanUnidad: this.unit.id,
      };
      this.filterBy = {
        field: "idPlanUnidadOA",
        value: item.id,
      };
    },
    hoursError(item: any): string {
      const totalHoursWeeks: number = this.semanas
        .flatMap((semana: any) => semana.planUnidadSemanaItemToList)
        .filter(
          (iteratedItem: any) =>
            iteratedItem.idPlanUnidadOA === item.id &&
            iteratedItem.tipo === 0 &&
            Number.isInteger(Number.parseInt(iteratedItem.horas))
        )
        .reduce(
          (acumulator: number, iteratedItem: any) =>
            acumulator + Number.parseInt(iteratedItem.horas),
          0
        );
      const color: string = totalHoursWeeks > item.hours ? "red" : "black";
      return color;
    },
    assignItem(type: number, addOaAutomatically: boolean = false) {
      this.request.tipo = type;
      this.selectedWeek.planUnidadSemanaItemToList.push(this.request);
      this.showingMenu = false;

      if (type == 1 && addOaAutomatically) {
        let request = _.cloneDeep(this.request);
        request.tipo = 0;
        request.ie_id = null;
        this.selectedWeek.planUnidadSemanaItemToList.push(request);
      }
    },
    searchActivity(week: any) {
      const activitiesWithoutOrder = UnitPlanActivity.query()
        .where("unitplan_id", this.unit.id)
        .with("duas")
        .with("files")
        .with("ies", (queryIE) => {
          queryIE.where((ie: any) => !ie.disabled && !ie.rescheduled);
        })
        .orderBy("id", "asc")
        .get();
      //plantype 0: Mes 1:Semana 2:Clase
      //activityType 3: Mes 2:Semana 1:Clase
      let activity = activitiesWithoutOrder.find((act) => act.semanaClase ? act.semanaClase.id == week.id : false);
      return activity == undefined ? 0 : activity.id;
    },
    openActivity(month, week) {
      this.monthSelected = month;
      this.weekItemSelected = week;
      const activitiesWithoutOrder = UnitPlanActivity.query()
        .where("unitplan_id", this.unit.id)
        .with("duas")
        .with("files")
        .with("ies", (queryIE) => {
          queryIE.where((ie: any) => !ie.disabled && !ie.rescheduled);
        })
        .orderBy("id", "asc")
        .get();
      this.selectedIEsForActivities = JSON.parse(JSON.stringify(this.oasAdded)).map(
        (OA: any) => {
          if (OA.oa != null) {
            OA.selectedRows = OA.oa.ies.filter(
              (ie: any) => {
                return week.planUnidadSemanaItemToList.find(details => details.ie_id && details.ie_id === ie.id)
              }
            );
          }
          return OA;
        }
      )
      let activity = activitiesWithoutOrder.find((act) => act.semanaClase ? act.semanaClase.id == week.id : false);
      if (activity) {
        this.appLoading();
        this.$store
          .dispatch("getUnitPlanActivity", activity.id).then((response) => {
            this.appLoading(false);
            activity.momentos = response.data.content.momentos;
            activity.pies = response.data.content.pies;
            this.selectedActivity = activity;
            this.dialogActivity = true;
          });
      } else {
        this.selectedActivity = activity == undefined ? null : activity;
        this.dialogActivity = true;
      }

    },
    selectItem(
      item: any,
      item_id: number,
      week: object,
      e: any,
      mark: any = null,
      type: string = "oa",
      idPlanUnidadOA?: number
    ) {
      if (
        !((this.userPrivileges.canEditCoverageAndActivitiesAndReprogramOAAndAdvanceAndComment && (this.userPrivileges.canEditOthersUnits || this.userId == this.unit.userIdPersona)) || this.isUTP)
      )
        return;
      e.preventDefault();
      // Request del Item
      this.request = {
        idPlanUnidadSemana: week.id,
        idPlanUnidadOA: type === "oa" ? item_id : idPlanUnidadOA,
        idPlanUnidadIndicador: null,
        ie_id: type === "ie" ? item_id : null,
        tipo: 0,
        horas: mark ? mark.horas : null,
      };
      this.selectedWeek = week;
      // reinicio la marca
      this.selectedMark = null;
      this.itemSelected = item;
      // Verificar menu a usar
      if (!mark) {
        if (type === "oa") {
          this.selectedMenu = this.menuOA;
        } else {
          this.assignItem(1, true);
          return;
        }
      } else {
        this.selectedMark = mark;
        if (type === "oa") {
          this.selectedMenu = this.altMenuOA;
        } else {
          let item = this.selectedWeek.planUnidadSemanaItemToList.find(
            (item: any) => item.ie_id === this.itemSelected.id
          );
          if (item.estadoRealizado === 3) {
            this.selectedMenu = this.altMenuIE2;
          } else {
            this.selectedMenu = this.altMenuIE;
          }
        }
      }

      this.showingMenu = false;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.verifyItemsSelected();
      this.$nextTick(() => {
        this.showingMenu = true;
      });
    },
    monthPaginator(acc: string = "next", num: number = 1) {
      if (
        acc === "next" &&
        this.selectedMonthIndex < this.unitplan_weeks.length - 2
      ) {
        this.selectedMonthIndex += num;
      } else if (acc === "prev" && this.selectedMonthIndex !== 0) {
        this.selectedMonthIndex -= num;
      }
      if (this.unitplan_weeks.length > 1) {
        this.selectedMonths = this.unitplan_weeks.slice(
          this.selectedMonthIndex,
          this.selectedMonthIndex + 2
        );
      } else {
        this.selectedMonths = this.unitplan_weeks;
      }

      this.verifyItemsSelected();
    },
    verifyItemsSelected() {
      let semanasConItems: any[] = [];

      // mes
      for (let i = 0; i < this.unitplan_weeks.length; i++) {
        // semana
        let semanas = JSON.parse(JSON.stringify(this.unitplan_weeks[i].semanas)).filter((week) => {
          week.planUnidadSemanaItemToList =
            week.planUnidadSemanaItemToList.filter((item: any) => {
              let objective: any;
              const puOA: any = this.oasAdded.find(
                (puOA: any) => puOA.id === item.idPlanUnidadOA
              );
              if (!puOA) return false;

              if (item.ie_id === null || item.ie_id === undefined) {
                objective = puOA;
              } else {
                objective = puOA.oa.ies.find((ie: any) => ie.id === item.ie_id);
              }
              return (
                !!objective && !objective.disabled && !objective.rescheduled
              );
            });
          return week.planUnidadSemanaItemToList.length > 0;
        });
        if (semanas.length > 0)
          semanasConItems.push(
            semanas.map((week) => {
              return {
                idPlanUnidadSemana: week.id,
                planUnidadSemanaItemTOList: week.planUnidadSemanaItemToList,
              };
            })
          );
      }

      this.haveItemsSelected = semanasConItems.length > 0;
    },
    verifyWeekState(week: any, oa: any) {
      if (oa.oa == null) return;

      let oaIEIds = oa.oa.ies.map((ie: any) => ie.id);
      let ies = week.planUnidadSemanaItemToList.filter((item: any) => oaIEIds.includes(item.ie_id));
      let allIesAreRealized = ies.every((ie: any) => ie.estadoRealizado == 3);
      if (ies.length > 0 && allIesAreRealized) {
        return 'realized-state';
      } else if (ies.length > 0) {
        return 'planned-state';
      } else {
        return 'not-planned-state';
      }
    },
    verifyOaState(item: any) {
      let itemPlanUnidadSemanaStates: any[] = [];
      if (!item || !item.oa || !item.oa.ies) return 'not-planned-state';

      item.oa.ies.forEach((ie: any) => {
        itemPlanUnidadSemanaStates.push(this.verifyItemState(ie));
      });
      const allItemAreRealized = itemPlanUnidadSemanaStates.every((ie: any) => ie == 'realized-state');
      const allItemArePlanned = itemPlanUnidadSemanaStates.every((ie: any) => ie != 'not-planned-state');
      if (itemPlanUnidadSemanaStates.length > 0 && allItemAreRealized) {
        return 'realized-state';
      } else if (itemPlanUnidadSemanaStates.length > 0 && allItemArePlanned) {
        return 'planned-state';
      } else {
        return 'not-planned-state';
      }
    },
    verifyItemState(item: any) {
      let itemPlanUnidadSemana: any[] = [];
      this.unitplan_weeks.forEach((month: any) => {
        month.semanas.forEach((week: any) => {
          week.planUnidadSemanaItemToList.forEach((ie: any) => {
            if (ie.ie_id == item.id) {
              itemPlanUnidadSemana.push(ie);
            }
          });
        });
      });
      const allItemAreRealized = itemPlanUnidadSemana.every((ie: any) => ie.estadoRealizado == 3);
      if (itemPlanUnidadSemana.length > 0 && allItemAreRealized) {
        return 'realized-state';
      } else if (itemPlanUnidadSemana.length > 0) {
        return 'planned-state';
      } else {
        return 'not-planned-state';
      }
    },
    async saveCoverage(refreshActivities: boolean = false) {
      this.appLoading();
      this.loading = true;
      const msj = {
        show: true,
        text: this.$vuetify.lang.t(
          "$vuetify.component.romaCoverage.endpointMessages.savedCoverageSuccess"
        ),
        color: "success",
      };

      let request = [];

      // mes
      for (let i = 0; i < this.unitplan_weeks.length; i++) {
        // semana
        let semanas = this.unitplan_weeks[i].semanas.filter((week) => {
          week.planUnidadSemanaItemToList =
            week.planUnidadSemanaItemToList.filter((item: any) => {
              let objective: any;
              const puOA: any = this.oasAdded.find(
                (puOA: any) => puOA.id === item.idPlanUnidadOA
              );
              if (!puOA) return false;

              if (item.ie_id === null || item.ie_id === undefined) {
                objective = puOA;
              } else {
                objective = puOA.oa.ies.find((ie: any) => ie.id === item.ie_id);
              }
              return (
                !!objective && !objective.disabled && !objective.rescheduled
              );
            });
          return week.planUnidadSemanaItemToList.length > 0;
        });
        if (semanas.length > 0)
          request.push(
            semanas.map((week) => {
              return {
                idPlanUnidadSemana: week.id,
                planUnidadSemanaItemTOList: week.planUnidadSemanaItemToList,
              };
            })
          );

      }
      let isSomeAdvance = this.unitplan_weeks
        .flatMap((month: any) => month.semanas)
        .flatMap((week: any) => week.planUnidadSemanaItemToList)
        .map((val: any) => {
          return {
            id: val.id,
            estadoRealizado: val.estadoRealizado,
          };

        }).some((val: any) => val.estadoRealizado == 3);
      let body: any = {
        planUnidadSemanaItems: flattenDeep(request),
        updatePercentages: !isSomeAdvance
      };
      let percentages = {};
      let status;
      let responsse = await this.$store
        .dispatch("setUnitPlanWeeks", body)
        .then((response) => {
          if (
            response.data &&
            response.data.status &&
            response.data.status.code === 1
          ) {
            //MES
            for (let i = 0; i < this.unitplan_weeks.length; i++) {
              // SEMANA
              for (let j = 0; j < this.unitplan_weeks[i].semanas.length; j++) {
                // Chequea que la semana tenga items
                if (
                  this.unitplan_weeks[i].semanas[j].planUnidadSemanaItemToList
                    .length <= 0
                )
                  continue;
                // Itera los items de la semana actual
                this.unitplan_weeks[i].semanas[
                  j
                ].planUnidadSemanaItemToList.forEach((item: any) => {
                  // Encuentra el item de la respuesta del backend equivalente al item iterado
                  const responseItem = response.data.content.items.find(
                    (resItem: any) =>
                      item.idPlanUnidadSemana === resItem.idPlanUnidadSemana &&
                      ((item.idPlanUnidadOA === resItem.idPlanUnidadOA &&
                        item.ie_id > 0 &&
                        resItem.ie_id > 0 &&
                        item.ie_id === resItem.ie_id) ||
                        (item.idPlanUnidadOA === resItem.idPlanUnidadOA &&
                          item.ie_id === null &&
                          resItem.ie_id === null))
                  );
                  // Actualiza campos del item iterado
                  item.id = responseItem.id;
                  //item.estadoRealizado = responseItem.estadoRealizado;
                });
              }
            }
            //Actualiza estado del plan unidad
            percentages = response.data.content.percentages;
            status = response.data.content.status;
            if (!isSomeAdvance && !(this.unit && this.unit.totalIesPlanned == this.unit.totalIesDefined)) {
              this.unit.updateStatus(response.data.content.status);
              //Actualiza porcentajes al plan unidad
              this.unit.updatePercentages(response.data.content.percentages);
            }
            //Inserta los comentarios de registro de cambio de estado
            const commentsToInsert = response.data.content.comments.filter(
              (comment: any) => !!comment
            );
            if (commentsToInsert.length > 0)
              UnitPlanComments.insert({ data: commentsToInsert });
            //Actualiza cuenta de items originales
            this.updateOriginalItemsCount();

            this.savedCoverage = true;
            this.$emit('saved-coverage', true);
          } else if (
            response.data &&
            response.data.status &&
            response.data.status.code === 3
          ) {
            msj.text = response.data.content.message;
            msj.color = "red";
          } else {
            msj.text = this.$vuetify.lang.t(
              "$vuetify.generals.endpointMessages.notProcessed"
            );
            msj.color = "red";
          }
        })
        .catch((error: any) => {
          console.error("Error al guardar cobertura", error);
          msj.text = this.$vuetify.lang.t(
            "$vuetify.generals.endpointMessages.notProcessed"
          );
          msj.color = "red";
        })
        .finally(() => {
          if (!(this.unit && this.unit.totalIesPlanned == this.unit.totalIesDefined) || msj.color == "red") {
            this.$store.state.snackbar = msj;
            setTimeout(() => {
              const remembermsj = {
                show: true,
                text: this.$vuetify.lang.t(
                  "$vuetify.component.romaCoverage.endpointMessages.remember"
                ),
                color: "warning",
              };
              this.$store.state.snackbar = remembermsj;
            }, 1500);
          }

          this.loading = false;
          this.appLoading(false);
        });
      if (msj.color == "success") {
        if (this.unit && this.unit.totalIesPlanned == this.unit.totalIesDefined) {
          await this.saveAdvance(refreshActivities, isSomeAdvance, percentages, status);
        } else if (refreshActivities) {
          this.$emit('refresh-activities');
        }
      }
    },
    async saveAdvance(refreshActivities: boolean = false, isSomeAdvance: boolean = false, percentages: any = null, status: any = null) {
      this.loading = true;
      this.appLoading();
      const msj = {
        show: true,
        text: this.$vuetify.lang.t(
          "$vuetify.component.romaCoverage.endpointMessages.savedCoverageSuccess"
        ),
        color: "success",
      };
      const request = {
        idPlanUnidad: this.unit.id,
        commands: { closePlan: true },
      };
      await this.$store
        .dispatch("setUnitPlanStatus", request)
        .then(async (response) => {
          if (
            response.data &&
            response.data.status &&
            response.data.status.code === 1
          ) {
            if (!isSomeAdvance) {
              this.unit.updatePercentages(percentages);
              if (percentages.porcentajeItemsPlanificado != 100) {
                this.unit.updateStatus(status);
              } else {
                this.unit.updateStatus({
                  status_plan: "En Planificación: Cerrado",
                  editing_status_id: 1,
                  plan_status_id: 0
                })
              }
            }

            UnitPlan.update({ data: this.unit });
            const request2: any = {
              idPlanUnidad: this.unit.id,
              updatePercentages: isSomeAdvance,
              planUnidadSemanaItemTOList: this.unitplan_weeks
                .flatMap((month: any) => month.semanas)
                .flatMap((week: any) => week.planUnidadSemanaItemToList)
                .map((val: any) => {
                  return {
                    id: val.id,
                    estadoRealizado: val.estadoRealizado,
                  };

                }).filter((val: any) => val.estadoRealizado != null),
            };
            const response = await this.$store.dispatch(
              "setUnitPlanWeeksAdvance",
              request2
            );
            if (response.data && response.data.status && response.data.status.code === 1) {
              if (isSomeAdvance) {
                this.unit.updateStatus(response.data.content.status);
                this.unit.updatePercentages(response.data.content.percentages);
              }

              if (response.data.content.comment)
                UnitPlanComments.insert({
                  data: response.data.content.comment,
                });
              msj.text = "¡Avance de la unidad Guardada!";
              await this.updatePlanAnual();
              this.$store.state.snackbar = msj;
            } else if (
              response.data &&
              response.data.status &&
              response.data.status.code === 3
            ) {
              msj.text = response.data.content.message;
              msj.color = "red";

              if (msj.text && msj.text.includes('aprobado')) {
                msj.text = 'Para registrar avance, el flujo requiere revisión de Utp.';
                this.$store.state.snackbar = msj;
              }
            }
          } else {
            msj.color = "red";
            msj.text = response.data.content.message;
          }


        })
        .catch((error) => {
          console.log(error);
        });
      this.loading = false;
      this.appLoading(false);
      if (refreshActivities) {
        this.$emit('refresh-activities');
      }
    },
    async updatePlanAnual() {
      const filter = this.$store.state.unitList.paginator.filter;
      const paginator = this.$store.state.unitList.paginator;
      const params = `idInstitucion=${filter.institution}&idAsignatura=${filter.subject}&idCategoria=${filter.level}&idPersona=${filter.teacher}&year=${filter.years}&page=${paginator.page}&itemsPerPage=${paginator.itemsPerPage}`;
      const request = new URLSearchParams(params);
      this.appLoading();
      try {
        await this.$store.dispatch('getAnualPlans', request).then(res => {
          this.appLoading(false);
          this.planAnualList(res.data.content.data);
        });
      } catch (e) {
        this.appLoading(false);
      }
    },


    rowStyle(itemIndex: number, disabled: boolean = false) {
      const colors = [
        "--v-roma_rcolor-lighten3",
        "--v-primary-base",
        "--v-secondary-base",
        "--v-roma_acolor-base",
      ];
      let color = `var(${colors[itemIndex % colors.length]})`;

      if (disabled || !this.applyRowColor) color = "grey";

      return color;
    },
    updateOriginalItemsCount() {
      this.originalItemsCount = this.unitplan_weeks
        .flatMap((month: any) => month.semanas)
        .flatMap((week: any) => week.planUnidadSemanaItemToList)
        .slice();
    },
    selectAllOAs() {
      if (this.selectedAll) {
        this.selectedRows = this.oasAdded;
        this.selectedRows.forEach((detail) => {
          detail.selectedRows = detail.oa.ies;
          detail.changeStatus = true;
        });
      } else {
        this.selectedRows.forEach((detail) => {
          detail.selectedRows = [];
        });
        this.selectedRows = [];
      }
    },
    goActivityTab(refresh: any) {
      if (refresh) {
        this.$emit('refresh-activities');
      }
    },
    assignItemAuto(request: any, type: number, addOaAutomatically: boolean = false) {
      request.tipo = type;
      this.selectedWeek.planUnidadSemanaItemToList.push(request);
      this.showingMenu = false;

      if (type == 1 && addOaAutomatically) {
        let requestOA = _.cloneDeep(request);
        requestOA.tipo = 0;
        requestOA.ie_id = null;
        this.selectedWeek.planUnidadSemanaItemToList.push(requestOA);
      }
    },
    activitySaved(event: any) {
      let request: any = {
        idPlanUnidadIndicador: null,
        idPlanUnidadSemana: event.week.id,
        tipo: 1,
        horas: null,
      };
      this.selectedWeek = event.week;
      event.oasSelected.forEach((oa: any) => {
        let poa = this.oasAdded.find((item: any) => {
          return item.oa_id == oa.id;
        });
        request.idPlanUnidadOA = poa ? poa.id : +oa.id;
        //remove duplicates from oa.indicadoresEvaluacion
        oa.idIndicadoresEvaluacion = [...new Set(oa.idIndicadoresEvaluacion)];
        oa.idIndicadoresEvaluacion.forEach((ie: any) => {
          if (!this.selectedWeek.planUnidadSemanaItemToList.some((item: any) => item.ie_id == ie)) {
            request.ie_id = ie;
            this.assignItemAuto(_.cloneDeep(request), 1, true);
          }
        });

        //remove non selected ies
        this.selectedWeek.planUnidadSemanaItemToList = this.selectedWeek.planUnidadSemanaItemToList.filter((item: any) => {
          return (oa.idIndicadoresEvaluacion.includes(item.ie_id) && item.idPlanUnidadOA == request.idPlanUnidadOA) || item.idPlanUnidadOA != request.idPlanUnidadOA || item.ie_id == null;
        });
      });

      this.saveCoverage(true);
    },
    selectOA(obj: any) {
      let { item, value } = obj;
      item.selectedRows = value ? item.oa.ies : []; // Selecciona todos los ies de un oa
      item.changeStatus = value;
    },
    selectIE(oa: object, { value }) {
      const index = this.selectedRows.indexOf(oa);
      if (value) {
        if (index === -1) this.selectedRows.push(oa); // agrega a oa seleccionado si se marca un ie
      } else {
        if (oa.selectedRows.length === 1) {
          this.selectedRows.splice(index, 1); // Si deshabilita el ultimo ie quito el oa de seleccionado
        }
      }
      this.verifyItemsSelected();
    },
    customFilter(value, search, item) {
      search = search.toLowerCase();
      return (
        item.oa.cod.toLowerCase().indexOf(search) > -1 ||
        item.oa.name.toLowerCase().indexOf(search) > -1
      );
    },
    getOAsByUnitPlanId() {
      this.loading = true;
      let request = new URLSearchParams(
        `idPlanUnidad=${this.unit.id}`
      );

      this.$store.dispatch("romaOAsBySubjectId", request).then(response => {
        let unitPlanIEs = [];
        if (response.data.content && response.data.content.length > 0) {
          response.data.content.forEach((item: any) => {
            if (item.oa.ies && item.oa.ies.length > 0) {
              unitPlanIEs = unitPlanIEs.concat(item.oa.ies);
            }
          });
        }

        this.unitPlanIEs = unitPlanIEs;
        this.unit.oa_count = response.data.content.filter((unitPlanOa: any) => {
          const someIeActive = unitPlanOa.oa.ies.some((ie: any) => !ie.disabled);
          return someIeActive;
        }).length;
        UnitPlanOa.insertOrUpdate({ data: response.data.content });
        this.loading = false;
      });
    }
  },
  components: {
    RomaOaModalForm,
    RomaMessageModal,
    RomaActivityModalForm,
    FilterIcon,
    PlusIcon,
    SaveIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckIcon,
    CheckSquareIcon,
    EyeIcon,
    EyeOffIcon,
    EditIcon
  },
  directives: {
    mask,
    Ripple,
  },
});
